<template>
  <div class="cmp-favorites-control">

    <a v-if="(!isFavoriteComputed && !touched) || (touched && !isFavorite)"
      @click="addToFavorites()"
      class="favorites-icon add-to">
      <i class="fa fa-list" aria-hidden="true"></i>
      <span v-if="useDescription" v-translation="{ type: 'button', code: 'button_add_to_orderlist' }" class="add-to-desc"></span>
    </a>

    <a v-else
      @click="removeFromFavorites()"
      class="favorites-icon remove">
      <i class="fa fa-list" aria-hidden="true"></i>
      <span v-if="useDescription" v-translation="{ type: 'button', code: 'button_remove_from_orderlist' }" class="remove-desc"></span>
    </a>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Product } from 'src/models/product.model';
export default {
  props: {
    useDescription: { type: Boolean, required: false, default: false },
    product: { type: Product, required: true },
    // BESPOKE
    orderListProducts: { type: Array, required: true }
    // END BESPOKE
  },
  data () {
    return {
      touched: false,
      isFavorite: false
    };
  },
  computed: {
    ...mapGetters(['addProductToListEndpoint', 'removeProductFromListEndpoint', 'customerId', 'clientCode']),
    isFavoriteComputed () {
      return this.orderListProducts.includes(this.product.id);
    }
  },
  methods: {
    addToFavorites () {
      // BESPOKE NOX-142
        const addProductToOrderListEndpoint = "/Webshop/WebshopAPI/ProductListWebmethods.aspx/AddProductToOrderList";
        axios.post(addProductToOrderListEndpoint, { prod_code: this.product.id }).then(res => {
          this.touched = !this.touched;
          this.isFavorite = true;
          this.$emit('addProductToOrderList', this.product.id);
        });
        // END BESPOKE NOX-142
    },
    removeFromFavorites () {
      // BESPOKE NOX-142
        const removeProductFromOrderListEndpoint = "/Webshop/WebshopAPI/ProductListWebmethods.aspx/RemoveProductFromOrderList";
          axios.post(removeProductFromOrderListEndpoint, { prod_code: this.product.id }).then(res => {
            this.touched = !this.touched;
            this.isFavorite = false;
            this.$emit('removeProductFromOrderList', this.product.id);
        });
        // END BESPOKE NOX-142
    }
  },
  created () {
    this.isFavorite = this.product.includedInCustomerLists.includes('orderlist');
  }
}
</script>

<style>

</style>
